import dayjs from "dayjs"
export const clientSegmentsFilterTransformer = response => {
  const data = response?.data || {}
  const segments = data?.segments || []

  const staffNames = new Set()
  const staffOptions = [{ label: "All", value: "all" }]

  const transformedSegments = segments.map(segment => {
    if (segment?.staffName && !staffNames.has(segment.staffName)) {
      staffNames.add(segment.staffName)
      staffOptions.push({
        label: segment.staffName,
        value: segment.staffName?.toLowerCase(),
      })
    }

    return {
      segmentId: segment?.segmentId,
      staffName: segment?.staffName || "",
      date: segment?.date,
      formattedDate: dayjs(segment?.date).format("MMM DD, YYYY"),
    }
  })

  const segmentOptions = [
    { label: "All", value: "all" },
    ...transformedSegments.map(s => ({
      label: `${s?.formattedDate} · ${s?.staffName}`,
      value: s?.segmentId,
      staffName: s?.staffName,
      formattedDate: s?.formattedDate,
    })),
  ]


  return {
    segments: transformedSegments,
    staffOptions,
    segmentOptions,
    totalSegments: transformedSegments.length,
  }
}
